import React from 'react';
import { Skeleton } from 'primereact/skeleton';

const SkeletonContentLoading = ({ type = 'tracking' }) => {
    if (type === 'tracking') {
        return (
            <div className="space-y-4">
                {/* Header/Info Card Skeleton */}
                <div className="bg-white rounded-xl border border-gray-100 p-6">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                        {[1, 2, 3, 4].map((i) => (
                            <div key={i} className="flex gap-3">
                                <Skeleton shape="circle" size="2.5rem" className="flex-shrink-0" />
                                <div className="space-y-2 w-full">
                                    <Skeleton width="40%" height="0.6rem" />
                                    <Skeleton width="80%" height="1rem" />
                                    <Skeleton width="60%" height="0.8rem" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Items Grid Skeleton */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    {[1, 2, 3, 4].map((i) => (
                        <div key={i} className="bg-white rounded-xl border border-gray-100 overflow-hidden">
                            <div className="bg-gray-50/50 p-4 border-b border-gray-100 flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <Skeleton shape="rectangle" size="2rem" />
                                    <div className="space-y-1">
                                        <Skeleton width="120px" height="1rem" />
                                        <Skeleton width="80px" height="0.7rem" />
                                    </div>
                                </div>
                                <Skeleton width="60px" height="1.2rem" />
                            </div>
                            <div className="p-4 space-y-4">
                                {[1, 2, 3].map((j) => (
                                    <div key={j} className="flex gap-4">
                                        <Skeleton shape="circle" size="0.8rem" className="mt-1 flex-shrink-0" />
                                        <div className="flex-1 space-y-2">
                                            <div className="flex items-center justify-between">
                                                <Skeleton width="40%" height="0.8rem" />
                                                <Skeleton width="20%" height="0.8rem" />
                                            </div>
                                            <Skeleton width="100%" height="0.1rem" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return <Skeleton width="100%" height="200px" />;
};

export default SkeletonContentLoading;
